export default __webpack_public_path__ + "static/media/mocha.09bec610.svg";